


















import { Component, Prop, Vue } from "vue-property-decorator";
import IncomeItem from "@/components/IncomeItem.vue";

@Component({ components: { IncomeItem } })
export default class IncomeStep extends Vue {
  @Prop() public list!: any[];
  @Prop() public listKey!: any[];
  @Prop() public listTotal!: any[];
}
